import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Repeat } from 'lucide-react';
export function Subscription() {
  return <section className="py-20 bg-brand-green text-brand-cream" data-id="element-142">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-lightGreen/30 backdrop-blur-sm border border-brand-lightGreen/50 rounded-3xl p-8 md:p-12" data-id="element-144">
          <div className="w-16 h-16 bg-brand-beige rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-145">
            <Repeat className="w-8 h-8 text-brand-green" data-id="element-146" />
          </div>

          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-brand-beige" data-id="element-147">
            Te orientamos antes de elegir
          </h2>

          <p className="text-lg text-brand-cream/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-148">
            Si quieres mantener una rutina constante, puedes consultar por
            opciones de compra según disponibilidad. Escríbenos por WhatsApp y
            te orientamos.
          </p>

          <a href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20las%20opciones%20de%20suscripci%C3%B3n" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-brand-beige text-brand-green text-base font-bold rounded-full hover:bg-white transition-colors shadow-lg hover:shadow-xl" data-id="element-149">
            Preguntar por Whatsapp
          </a>
        </motion.div>
      </div>
    </section>;
}